export default __webpack_public_path__ + "static/media/talentlogo2.7f1c714c.png";